@let listDataValue = listData();
@let tabsListDataValue = tabsListData();
@let activeTabValue = activeTab();
@let availableTabsValue = availableTabs();

<ng-template #defaultOfferTemplate let-offer>
  @if (offer.status) {
    <rt-offer-status-indicator [offerStatus]="offer" />
  }
  <div class="title-location">
    <rt-heading>{{ offer.title }}</rt-heading>
    <div layout-centered-y>
      @if (offer.department) {
        <span
          #departmentRef
          [rtTooltip]="offer.department"
          [rtTooltipPosition]="'below'"
          [rtTooltipEnableWhenTruncated]="true"
          [class.restricted]="offer.locationIds?.length"
          class="department"
        >
          {{ offer.department }}
        </span>
      }
      @if (offer.locationIds?.length) {
        @if (offer.department) {
          <rt-divider variant="dot" />
        }
        <rt-assigned-locations-info-container [locationIds]="offer.locationIds" />
      }
    </div>
  </div>
</ng-template>

<rt-box variant="vertical background no-padding">
  @if (!isLoading()) {
    <div class="search">
      <rt-form-field>
        <rt-input
          variant="rounded"
          [placeholder]="'app.common.placeholders.search.offers_search.other' | translate"
          [autoFocus]="true"
          [formControl]="searchControl"
          [hasClearButton]="true"
          (reset)="resetSearch()"
        >
          <rt-icon prefix name="search" />
        </rt-input>
      </rt-form-field>
      <div layout layout-space-between>
        <rt-tabs margin-lr-small>
          @for (tab of availableTabsValue; track $index) {
            <rt-tab
              [class.current]="tab === activeTabValue"
              [count]="listDataValue[tab]?.length || 0"
              (click)="changeTab(tab)"
            >
              {{ tabsListDataValue[tab].title }}
            </rt-tab>
          }
        </rt-tabs>
        @if (tabsListDataValue[activeTabValue].sortable) {
          <div layout layout-space-between layout-align-items-center class="header-container">
            <ng-container>
              <rt-button
                (click)="sortDropdown.open = !sortDropdown.open"
                #sortDropdownOrigin="rtOverlayOrigin"
                rt-overlay-origin
                [dropdownOpened]="sortDropdown.open"
                variant="plain"
                margin-right-small
                padding-right-small-x
              >
                <rt-icon name="sort" margin-right-small-xx />
                {{ sortButtonLabel }}
              </rt-button>
              <ng-template
                #sortDropdown="rtConnectedOverlay"
                [origin]="sortDropdownOrigin"
                (backdropClick)="sortDropdown.open = false"
                rt-connected-overlay
                hasBackdrop
              >
                <rt-dropdown [width]="DropdownWidth.SmallX">
                  <rt-dropdown-header [fullWidthTitle]="true">
                    {{ 'app.offers.sort_by.dropdown_title' | translate }}
                  </rt-dropdown-header>
                  @for (sortOption of sortOptionsToArray; track sortOption) {
                    <rt-dropdown-item (click)="changeSortOption(sortOption)">
                      {{ getSortLabelTranslation(sortOption) }}
                    </rt-dropdown-item>
                  }
                </rt-dropdown>
              </ng-template>
            </ng-container>
          </div>
        }
      </div>
    </div>

    <div class="groups">
      @for (tab of availableTabsValue; track $index; let first = $first) {
        @if (tab === activeTabValue) {
          <div class="results" rtScrollable>
            @if (listDataValue[tab]?.length) {
              @if (!hasSearchEmptyState()) {
                @for (group of tabsListDataValue[tab].itemGroups; track $index) {
                  @if (group?.groupTitle) {
                    <div class="tabs-group-header" layout layout-align-items-center>
                      <rt-heading variant="subheading" margin-right-small-xx>
                        {{ group.groupTitle }} ({{ group.items.length }})
                        <ng-template #groupTitle>
                          {{ group.groupTitle }} ({{ group.items.length }})
                        </ng-template>
                      </rt-heading>
                    </div>
                  }
                  @for (offer of group.items; track offer.id) {
                    <div class="result">
                      <div>
                        <rt-group
                          [class.checked]="getSelectedListGroup(tab)[offer.id]"
                          (click)="toggleItem(offer, tab)"
                          variant="horizontal"
                        >
                          <rt-checkbox
                            [checked]="getSelectedListGroup(tab)[offer.id]"
                            (click)="toggleItem(offer, tab)"
                          />
                          <ng-container
                            *ngTemplateOutlet="
                              offerTemplate() || defaultOfferTemplate;
                              context: { $implicit: offer }
                            "
                          />
                        </rt-group>
                        <rt-divider />
                      </div>
                    </div>
                  }
                }
              } @else {
                <rt-empty-state
                  [title]="'app.common.no_results_found' | translate"
                  variant="small"
                  icon="search"
                >
                  <rt-button (click)="resetSearch()" variant="tertiary">
                    {{ 'app.assignments.editor.clear_search' | translate }}
                  </rt-button>
                </rt-empty-state>
              }
            } @else {
              <rt-empty-state
                [title]="tabsListDataValue[tab].emptyStateTitle"
                variant="small"
                icon="work"
              />
            }
          </div>
        }
      }
    </div>
  } @else {
    <rt-spinner />
  }
</rt-box>
